// extracted by mini-css-extract-plugin
export default {"wrapper":"pagination_wrapper__IChDF","container":"pagination_container__49Rps","pagination":"pagination_pagination__p3vlZ","chevron":"pagination_chevron__ZZZ+1"};